module.exports = __webpack_public_path__ + "img/14.54fdd149.jpg";